// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9c64b364","674":"b1f18f9f"}[chunkId] + ".chunk.js";
};